import { PageHeader } from "@/pages/Categories";
import { ShieldCheck, FileText, FlaskConical, ClipboardCheck, AlertTriangle } from "lucide-react";

const CHECKS = [
  { icon: FileText, t: "Documentation review", d: "GST, IEC, registration, factory licenses, ISO / category certifications where applicable." },
  { icon: ShieldCheck, t: "Capability validation", d: "Production capacity, equipment, workforce, prior export references and category track record." },
  { icon: FlaskConical, t: "Sample & lab coordination", d: "Sample requests, courier, third-party lab tests for COA / SDS / heavy metals / IFRA where relevant." },
  { icon: ClipboardCheck, t: "Factory checks", d: "On-the-ground factory visits or third-party inspections coordinated on a per-brief basis." },
];

const DOCS = [
  "Certificate of Analysis (COA)",
  "Safety Data Sheet (SDS)",
  "IFRA conformity (fragrance, where relevant)",
  "Product specification sheets",
  "Test reports (heavy metals, microbial, fibre, etc.)",
  "Packing list & commercial invoice",
  "Certificate of Origin (COO)",
  "Bill of Lading / Airway Bill",
  "Inspection reports (pre-shipment / in-line)",
];

export default function SupplierVerification() {
  return (
    <div data-testid="verification-page">
      <PageHeader
        eyebrow="SUPPLIER VERIFICATION"
        title="Case-by-case verification. Documented handover."
        sub="We coordinate supplier verification, documents and compliance checks tailored to each category and buyer."
      />
      <section className="max-w-7xl mx-auto px-6 lg:px-8 pb-20">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
          {CHECKS.map((c, i) => (
            <div key={c.t} className="border border-white/5 bg-zinc-900/40 rounded-lg p-6" data-testid={`verif-${i}`}>
              <div className="flex items-center gap-3">
                <div className="h-9 w-9 rounded-md border border-white/10 grid place-items-center bg-zinc-950">
                  <c.icon className="h-4 w-4 text-amber-400" />
                </div>
                <div className="font-display text-lg font-semibold">{c.t}</div>
              </div>
              <p className="mt-3 text-[13.5px] text-zinc-400 leading-relaxed">{c.d}</p>
            </div>
          ))}
        </div>

        <div className="mt-12 border border-white/10 bg-zinc-950 rounded-lg p-8" data-testid="docs-block">
          <div className="font-mono text-[11px] tracking-[0.22em] text-amber-400">DOCUMENTATION WE CAN HELP COORDINATE</div>
          <h2 className="mt-2 font-display text-2xl font-semibold">Standard documents across categories</h2>
          <ul className="mt-5 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-2 text-[13.5px] text-zinc-300">
            {DOCS.map((d) => (
              <li key={d} className="flex items-start gap-2 border border-white/5 bg-zinc-900/40 rounded-md px-3 py-2.5">
                <FileText className="h-3.5 w-3.5 text-amber-400 mt-[3px] shrink-0" />
                {d}
              </li>
            ))}
          </ul>
        </div>

        <div className="mt-10 border border-amber-400/20 bg-amber-400/[0.04] rounded-lg p-6 flex gap-4" data-testid="disclaimer-block">
          <AlertTriangle className="h-5 w-5 text-amber-400 shrink-0 mt-0.5" />
          <div>
            <div className="font-display text-base font-semibold">Disclaimer</div>
            <p className="text-[13.5px] text-zinc-300 mt-1 leading-relaxed">
              VYR Trade is a sourcing and trade facilitation company — not a manufacturer, unless explicitly stated.
              We do not claim that we or our suppliers carry generic certifications such as &quot;ISO certified&quot; — supplier-specific certifications and documents are verified and shared case by case.
              Compliance with EU / UK regulations remains the buyer&apos;s responsibility; we support documentation coordination.
            </p>
          </div>
        </div>
      </section>
    </div>
  );
}
